import { Callout, DelayedRender, getTheme, List, Stack, Text, TooltipHost } from '@fluentui/react';
import { IC } from 'components/SVGIcon';
import { IvicosColors } from 'kits/colorKit';
import IconKit from 'kits/IconKit';
import { QuestionCircle } from 'kits/IconKit2';
import IvicosStrings from 'kits/language/stringKit';
import React from 'react';
import styled from 'styled-components';

interface IBasicListViewProps {
    isCalloutVisible: boolean;
    styles: any;
    toggleIsCalloutVisible: any;
    buttonId: string;
    directionalHint: any;
    onBasicListChange: (ev: any, option: any) => void;
    label?: string;
    items: string[];
    callout?: string;
    disabled?: boolean;
    height?: string;
    overflow?: string;
}

const truncateName = (name: string, maxLength = 23): string => {
    if (name.length <= maxLength) return name;

    const truncated = name.substring(0, maxLength);
    return truncated.replace(/\s+$/, '') + '...';
};

const BasicListView: React.FC<IBasicListViewProps> = (props) => {
    const { isCalloutVisible, styles, toggleIsCalloutVisible, buttonId, directionalHint, onBasicListChange, label, items, callout, height } = props;

    const theme = getTheme();

    const renderListCell = (item: any) => {
        const IconContainer = styled.div`
            position: relative;
            width: 44px;
            height: 44px;
            display: flex;
            align-items: center;
            justify-content: center;
        `;

        const MatchBadge = styled.div`
            position: absolute;
            top: 50%;
            right: 8px;
            transform: translateY(-50%);
            width: 24px;
            height: 24px;
            background-color: red;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            z-index: 1;
        `;
        const Wrapper = styled.section`
            cursor: pointer;
            user-select: none;
            [tabIndex]:focus {
                background-color: ${IvicosColors.Mittelblau};
                color: white;
            }
            :hover {
                background-color: ${IvicosColors.Grau50};
            }
        `;

        const UserIcon = () => (
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="13" viewBox="0 0 11 10" fill="none">
                <path
                    d="M5.5 0C4.98438 0 4.54542 0.208212 4.26357 0.525293C3.98172 0.842374 3.85 1.24896 3.85 1.65C3.85 2.05104 3.98172 2.45763 4.26357 2.77471C4.54542 3.09179 4.98438 3.3 5.5 3.3C6.01563 3.3 6.45458 3.09179 6.73643 2.77471C7.01828 2.45763 7.15 2.05104 7.15 1.65C7.15 1.24896 7.01828 0.842374 6.73643 0.525293C6.45458 0.208212 6.01563 0 5.5 0ZM1.925 0.55C1.50104 0.55 1.13084 0.723837 0.894824 0.989355C0.658808 1.25487 0.55 1.59271 0.55 1.925C0.55 2.25729 0.658808 2.59513 0.894824 2.86064C1.13084 3.12616 1.50104 3.3 1.925 3.3C2.34896 3.3 2.71916 3.12616 2.95518 2.86064C3.19119 2.59513 3.3 2.25729 3.3 1.925C3.3 1.59271 3.19119 1.25487 2.95518 0.989355C2.71916 0.723837 2.34896 0.55 1.925 0.55ZM9.075 0.55C8.65104 0.55 8.28084 0.723837 8.04482 0.989355C7.80881 1.25487 7.7 1.59271 7.7 1.925C7.7 2.25729 7.80881 2.59513 8.04482 2.86064C8.28084 3.12616 8.65104 3.3 9.075 3.3C9.49896 3.3 9.86916 3.12616 10.1052 2.86064C10.3412 2.59513 10.45 2.25729 10.45 1.925C10.45 1.59271 10.3412 1.25487 10.1052 0.989355C9.86916 0.723837 9.49896 0.55 9.075 0.55ZM5.5 0.825C5.80937 0.825 5.98917 0.926163 6.11982 1.07314C6.25047 1.22013 6.325 1.43229 6.325 1.65C6.325 1.86771 6.25047 2.07987 6.11982 2.22686C5.98917 2.37384 5.80937 2.475 5.5 2.475C5.19063 2.475 5.01083 2.37384 4.88018 2.22686C4.74953 2.07987 4.675 1.86771 4.675 1.65C4.675 1.43229 4.74953 1.22013 4.88018 1.07314C5.01083 0.926163 5.19063 0.825 5.5 0.825ZM1.925 1.375C2.14271 1.375 2.25376 1.44179 2.33857 1.53721C2.42339 1.63263 2.475 1.77604 2.475 1.925C2.475 2.07396 2.42339 2.21737 2.33857 2.31279C2.25376 2.40821 2.14271 2.475 1.925 2.475C1.70729 2.475 1.59624 2.40821 1.51143 2.31279C1.42661 2.21737 1.375 2.07396 1.375 1.925C1.375 1.77604 1.42661 1.63263 1.51143 1.53721C1.59624 1.44179 1.70729 1.375 1.925 1.375ZM9.075 1.375C9.29271 1.375 9.40376 1.44179 9.48857 1.53721C9.57339 1.63263 9.625 1.77604 9.625 1.925C9.625 2.07396 9.57339 2.21737 9.48857 2.31279C9.40376 2.40821 9.29271 2.475 9.075 2.475C8.85729 2.475 8.74624 2.40821 8.66143 2.31279C8.57661 2.21737 8.525 2.07396 8.525 1.925C8.525 1.77604 8.57661 1.63263 8.66143 1.53721C8.74624 1.44179 8.85729 1.375 9.075 1.375ZM0.9625 3.85C0.43175 3.85 0 4.28175 0 4.8125V6.6C0 7.81275 0.98725 8.8 2.2 8.8C2.39525 8.8 2.58515 8.77538 2.76665 8.72588C2.65115 8.47838 2.56579 8.21408 2.51904 7.93633C2.41729 7.96108 2.31 7.975 2.2 7.975C1.441 7.975 0.825 7.359 0.825 6.6V4.8125C0.825 4.7355 0.8855 4.675 0.9625 4.675H2.48306C2.51056 4.3615 2.63169 4.07825 2.82144 3.85H0.9625ZM3.9875 3.85C3.46089 3.85 3.025 4.28589 3.025 4.8125V7.425C3.025 8.787 4.138 9.9 5.5 9.9C6.862 9.9 7.975 8.787 7.975 7.425V4.8125C7.975 4.28589 7.53911 3.85 7.0125 3.85H3.9875ZM8.17856 3.85C8.36831 4.07825 8.48944 4.3615 8.51694 4.675H10.0375C10.1145 4.675 10.175 4.7355 10.175 4.8125V6.6C10.175 7.359 9.559 7.975 8.8 7.975C8.69 7.975 8.58271 7.96108 8.48096 7.93633C8.43421 8.21408 8.34885 8.47838 8.23335 8.72588C8.41485 8.77538 8.60475 8.8 8.8 8.8C10.0128 8.8 11 7.81275 11 6.6V4.8125C11 4.28175 10.5683 3.85 10.0375 3.85H8.17856ZM3.9875 4.675H7.0125C7.09364 4.675 7.15 4.73136 7.15 4.8125V7.425C7.15 8.3411 6.4161 9.075 5.5 9.075C4.5839 9.075 3.85 8.3411 3.85 7.425V4.8125C3.85 4.73136 3.90636 4.675 3.9875 4.675Z"
                    fill={theme.palette.white}
                />
            </svg>
        );

        return (
            <Wrapper>
                <TooltipHost content={`${item.text} ${IvicosStrings.roomIsOccupied}`} id={`tooltip-${item.key}`} hidden={item.users.length <= 0}>
                    <Stack tabIndex={1} onClick={(e: any) => onBasicListChange(e, item.key)} tokens={{ childrenGap: 8 }} style={{ position: 'relative' }}>
                        <Stack horizontal tokens={{ childrenGap: 8 }} verticalAlign="center" style={{ paddingRight: '40px' }}>
                            <IconContainer>
                                <IconKit.Icon icon={IconKit.getIcon('Rooms', item.icon)} />
                            </IconContainer>
                            <Stack>
                                <Text variant="medium" style={{ color: 'inherit' }}>
                                    {truncateName(item.text)}
                                </Text>
                            </Stack>
                            {item.users.length > 0 && (
                                <MatchBadge>
                                    <UserIcon />
                                </MatchBadge>
                            )}
                        </Stack>
                    </Stack>
                </TooltipHost>
            </Wrapper>
        );
    };

    return (
        <Stack>
            <Stack>
                <Stack horizontal horizontalAlign="space-between">
                    {label ? (
                        <Stack>
                            <Text style={{ fontWeight: 'bold' }}>{label}</Text>
                        </Stack>
                    ) : null}
                    {callout != undefined ? (
                        <Stack>
                            <IC variant="custom" size={15} style={{ cursor: 'pointer' }}>
                                <QuestionCircle onClick={toggleIsCalloutVisible} id={buttonId} />
                            </IC>
                        </Stack>
                    ) : null}
                </Stack>
                <Stack horizontal={false} style={{ width: '100%', maxHeight: height, overflow: 'auto' }}>
                    <List items={items} onRenderCell={renderListCell}></List>
                </Stack>
            </Stack>

            {isCalloutVisible && (
                <Callout
                    className={styles.callout}
                    onDismiss={toggleIsCalloutVisible}
                    role="status"
                    target={`#${buttonId}`}
                    aria-live="assertive"
                    directionalHint={directionalHint}
                >
                    <DelayedRender>
                        <Text variant="small">{callout}</Text>
                    </DelayedRender>
                </Callout>
            )}
        </Stack>
    );
};

export default BasicListView;
